import React from 'react';

import styles from './styles';

const {
    InfoBlockBox,
    InfoBlockLabel,
    InfoBlockText,
    InfoBlockStatus,
} = styles;

class InfoBlock extends React.Component {
    render() {
        const {
            status,
            statusDescriprion,
            title,
            value,
        } = this.props;

        return (
            <InfoBlockBox>
                <InfoBlockLabel>
                    {title}
                </InfoBlockLabel>
                <InfoBlockText status={status}>
                    {status !== null ? <InfoBlockStatus status={status} dataTitle={statusDescriprion} /> : null}
                    {value}
                </InfoBlockText>
            </InfoBlockBox>
        );
    }
}

export default InfoBlock;
